<template>
  <div class="wrapper">
    <div
      :style="{justifyContent: typeId == 1 ? 'space-between' : 'flex-end'}"
      class="hd"
    >
      <button
        v-if="typeId == 1"
        :class="{'disabled': disableRefreshAll}"
        class="btn btn_refresh"
        @click="refreshAll"
      >
        <img
          v-if="!disableRefreshAll"
          class="icon"
          src="http://img.yimutian.com/crm/5d1196387960423e111738f9e1d56ef6.png"
        >
        {{ disableRefreshAll ? '普通用户1次每天' : '一键刷新所有供应' }}
      </button>
      <div class="operate_bar">
        <button
          v-if="typeId == 1"
          :class="{'disabled': !selectedSupplyIdArr.length}"
          class="btn btn_primary"
          @click="refreshMulti"
        >
          <img
            v-if="!selectedSupplyIdArr.length"
            class="icon"
            src="http://img.yimutian.com/crm/5d11e85a7960423e11177061fb41f540.png"
            alt=""
          >
          <img
            v-else
            class="icon"
            src="http://img.yimutian.com/crm/5d1195e27960423e111738acf4c047f6.png"
            alt=""
          >刷新
        </button>
        <button
          v-if="typeId == 1"
          :class="{'disabled': !selectedSupplyIdArr.length}"
          class="btn btn_primary"
          @click="closeMulti"
        >
          <img
            v-if="!selectedSupplyIdArr.length"
            class="icon"
            src="http://img.yimutian.com/crm/5d11e2f0885b9303cb1786aced88611a.png"
            alt=""
          >
          <img
            v-else
            class="icon"
            src="http://img.yimutian.com/crm/5d11a6d77960423e11174399f4436620.png"
            alt=""
          >下架
        </button>
        <button
          v-if="typeId != 1"
          :class="{'disabled': !selectedSupplyIdArr.length}"
          class="btn btn_primary"
          @click="delMulti"
        >
          <img
            v-if="!selectedSupplyIdArr.length"
            class="icon"
            src="http://img.yimutian.com/crm/5d11e2f0885b9303cb1786ada6740e5a.png"
            alt=""
          >
          <img
            v-else
            class="icon"
            src="http://img.yimutian.com/crm/5d11a6d8885b9303cb175e38ec82e27d.png"
            alt=""
          >删除
        </button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="list"
      :default-sort="{prop: 'updated_time', order: 'descending'}"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" />
      <el-table-column
        label="供应"
        width="262px"
      >
        <template slot-scope="scope">
          <div
            :style="{paddingBottom: typeId == 2 && scope.row.refuse_reason ? '30px' : '0'}"
            class="goods"
          >
            <img
              :src="(scope.row.cover_image || 'http://img.yimutian.com/misc/5cb45e835c26555cbd1695367cfbca1d.png') | aspectFill(60, 60)"
              class="main_pic"
              alt=""
            >
            <div class="detail">
              <div
                class="name"
                @click="toEdit(scope.row.supply_id)"
              >
                <span style="color: #FF4F01;">{{ scope.row.stall == 1? '[推荐]' : '' }}</span><span
                  class="subname"
                >{{ scope.row.title+'' }}{{ String(scope.row.lastPrice).indexOf('~') > -1 ? String(scope.row.lastPrice).split('~')[0] : scope.row.lastPrice }}
                  {{ ' '+scope.row.unit }}</span>
              </div>
              <div class="supply_no">
                供应编号：{{ scope.row.supply_id }}
              </div>
            </div>
          </div>
          <div
            v-if="typeId == 2 && scope.row.refuse_reason"
            class="refuse"
          >
            <el-tooltip
              :content="scope.row.refuse_reason"
              class="item"
              effect="dark"
              placement="top"
            >
              <div class="refuse_hd">
                <img
                  src="http://img.yimutian.com/misc/5d11badb7960423e1117515167620336.png"
                  alt=""
                >
                <p
                  style="display: inline-block;margin: 0;max-width: 700px;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;word-break: break-all;"
                >
                  {{ scope.row.refuse_reason }}
                </p>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="价格（元）">
        <template slot-scope="scope">
          <p style="color: #FF4F01;margin: 0;padding-left: 2px;">
            {{ scope.row.lastPrice }}
          </p>
          <!-- <el-popover
            :ref="'popover_'+scope.row.supply_id"
            placement="bottom"
            trigger="click"
            width="460"
          >
            <ul style="padding: 28px 18px 18px;">
              <li
                v-for="(sku, index) in scope.row.supplies_sku"
                :key="index"
                class="sku_row row"
                style="list-style: none;"
              >
                <div
                  class="form_group"
                  style="display: flex;height: 30px;align-items: center;border: 0 none;"
                >
                  <div
                    class="label"
                    style="display: flex;align-items: center;width: 57px;height: 30px;"
                  >
                    规格{{ index+1 }}
                  </div>
                  <div
                    class="form_control"
                    style="border: 0 none;"
                  >
                    <input
                      v-model="sku.title"
                      type="text"
                      style="border: 1px solid #b7b7b7;width: 100%;height: 30px;box-sizing: border-box;border-radius: 2px;"
                      placeholder="自定义商品规格"
                      disabled
                    >
                  </div>
                  <div class="form_control money_input">
                    <input
                      v-model="sku.price"
                      type="text"
                      style="color:rgb(255, 79, 1)"
                      @input="checkInput($event, scope.row, index)"
                    >
                  </div>
                </div>
              </li>
              <p
                class="sku_desc"
                style="margin: 0;"
              >
                仅支持价格修改，如需添加规格请详情页修改
              </p>
              <p style="margin: 20 0 0;text-align: center;">
                <button
                  class="btn btn_operate"
                  style="margin-right: 20px;"
                  @click="pCancel(scope.row.supply_id)"
                >
                  取消
                </button><button
                  class="btn btn_operate btn_operate_confirm"
                  @click="pSubmit(scope.row)"
                >
                  确定
                </button>
              </p>
            </ul>
            <el-button
              v-if="scope.row.supplies_sku && scope.row.supplies_sku.length"
              slot="reference"
              style="background-color: transparent;padding: 0;"
              type="text"
              @click="pOpen(scope.row.supply_id)"
            >
              <img
                src="http://img.yimutian.com/crm/5d11a6d8885b9303cb175e3b73e1e836.png"
                alt=""
                style="width: 18px;height: 18px;"
              >
            </el-button>
          </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column label="交易选项">
        <template slot-scope="scope">
          <p style="margin: 0">
            <span>{{ scope.row.advanced | formatTradeStyle }}</span>
          </p>
          <p style="margin: 0">
            <span>{{ scope.row.advanced | formatExpressStyle }}</span>
          </p>
          <p style="margin: 0">
            <span>{{ scope.row.advanced | formatSamllAmount }}</span>
          </p>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatRefreshTime"
        prop="updated_time"
        sortable
        label="刷新时间"
        show-overflow-tooltip
      />
      <el-table-column
        prop="view_info"
        label="访问量"
      />
      <el-table-column
        label="操作"
        width="140px"
      >
        <template slot-scope="scope">
          <div class="operation">
            <button
              v-if="typeId == 1"
              :style="{color: refreshedList.indexOf(scope.row.supply_id) > -1 ? 'rgba(51,136,255,0.5)' : 'rgba(51,136,255,1)'}"
              class="btn btn_xs"
              @click="refresh(scope.row.supply_id)"
            >
              刷新
            </button>
            <button
              class="btn btn_xs"
              @click="toEdit(scope.row.supply_id)"
            >
              编辑
            </button>
            <button
              v-if="typeId == 1"
              class="btn btn_xs"
              @click="toOutStock(scope.row.supply_id)"
            >
              <img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439b41f7d7d9.png"
                alt=""
              >
            </button>
            <button
              v-if="typeId == 0"
              class="btn btn_xs"
              style="transform: rotate(180deg)"
              @click="toInStock(scope.row.supply_id)"
            >
              <img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439b41f7d7d9.png"
                alt=""
              >
            </button>
            <button
              class="btn btn_xs"
              @click="toDel(scope.row.supply_id)"
            >
              <img
                src="http://img.yimutian.com/crm/5d11a6d87960423e1117439a005cdac4.png"
                alt=""
              >
            </button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="paginator_wrap">
      <paginator
        v-if="list && list.length"
        ref="paginator"
        :page-count="pageCount"
        :per-page-size="pageSize"
        :total-count="totalCount"
        :init-page="curPage"
        @togglePage="togglePage($event)"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { MessageBox, Message } from 'element-ui'
import { supply, publish } from '@/api'
import paginator from '../components/Paginator'
import * as utils from '@/utils.js'
const listTypeObj = {
  '1029': 1, // 上市中
  
  '1030': 0, //  已下架
  '1031': 2 // 待修改
}
export default {
  components: {
    paginator
  },
  filters: {
    formatTradeStyle: function(arr) {
      const tempObj = arr && arr.find && arr.find(x => x.attr_id == 1 && x.choose_type == 1)
      if (typeof tempObj === 'object' && Object.keys(tempObj).length) {
        return tempObj.options[0].display_name
      }
      return ''
    },
    formatExpressStyle: function(arr) {
      const tempObj = arr && arr.find && arr.find(x => x.attr_id == 5 && x.choose_type == 1)
      if (typeof tempObj === 'object' && Object.keys(tempObj).length) {
        return tempObj.options[0].display_name
      }
      return ''
    },
    formatSamllAmount: function(arr) {
      const tempObj = arr && arr.find && arr.find(x => x.attr_id == 2 && x.choose_type == 3)
      if (typeof tempObj === 'object' && Object.keys(tempObj).length) {
        return tempObj.display_name + tempObj.value + tempObj.suffix
      }
      return ''
    }
  },
  data() {
    return {
      ajaxLock: false,
      refreshedList: [], // 已刷新的supplylist
      curSupplyObj: {}, // 待编辑sku信息
      curPage: 1,
      totalCount: 0, // 总条数
      pageStart: 0,
      pageSize: 5,
      pageCount: 0, // 总页数
      showThePop: false,
      typeId: this.$route.params.typeId
        ? listTypeObj[this.$route.params.typeId]
        : 1, // 1 上架 0 下架 2 拒审
      disableRefreshAll: false, // 一键刷新供应
      page: 0,
      list: [],
      multipleSelection: [], // 选中的行
      selectedSupplyIdArr: [] // 选中的行supplyId
    }
  },
  created() {
    this.getList() // 获取列表
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.typeId !== from.params.typeId) {
      this.typeId = listTypeObj[to.params.typeId]
      this.pageStart = 0
      this.curPage = 1
      this.list = []
      this.getList()
      next()
    }
  },
  methods: {
    // 输入框限制两位小数
    checkInput(e, row, index) {
      e.target.value =
        e.target.value.match(/^\d*(\.?\d{0,2})/g) ||
        e.target.value.match(/^\d*(\.?\d{0,2})/g)[0] ||
        null

      this.list
        .filter(x => x.supply_id == row.supply_id)
        .map(i => {
          i.supplies_sku = i.supplies_sku.map((m, idx) => {
            if (idx == index) {
              return { price: e.target.value, title: m.title, unit: m.unit }
            } else {
              return { price: m.price, title: m.title, unit: m.unit }
            }
          })
          return i
        })
    },
    pSubmit: utils.debounce(
      function(row) {
        if (this.ajaxLock) return
        this.ajaxLock = true
        // 编辑sku即 编辑供应
        const paramOb = row
        // 完整sku校验
        const checkSku = row.supplies_sku.every(i => i.price)
        if (!checkSku) {
          Message.info({
            message: '请检查sku价格,sku价格是否填写错误',
            duration: 4000
          })
          this.ajaxLock = false
          return
        }
        let requestData = {
          ...this.curPartSupplyObj,
          supplies_sku: row.supplies_sku.map(i => {
            return {
              price: Math.round(i.price * 100),
              title: i.title,
              unit: i.unit
            }
          }),
          video_img: this.curPartSupplyObj.video_img.map(file => {
            if (file.file_type == 0) {
              return {
                p_url:
                  file.p_url.indexOf('http://img.yimutian.com/') > -1
                    ? file.p_url.slice(24)
                    : file.p_url,
                file_type: 0
              }
            }
            return {
              pre_url: file.pre_url,
              v_url:
                file.v_url.indexOf('http://video.yimutian.com/') > -1
                  ? file.v_url.slice(26)
                  : file.v_url,
              file_type: 1
            }
          }),
          price: row.supplies_sku.reduce((small, cur) => {
            if (small > cur.price - '') {
              small = cur.price
            }
            return Math.round(small * 100)
          }, row.supplies_sku[0].price)
        }
        // 更新最小价格，最大价格
        let large_price = row.supplies_sku.reduce((large, cur) => {
          if (large < cur.price - '') {
            large = cur.price
          }
          return large
        }, 0)
        let small_price = ''
        if (row.supplies_sku.length) {
          small_price = row.supplies_sku.reduce((small, cur) => {
            if (small > cur.price - '') {
              small = cur.price
            }
            return small
          }, row.supplies_sku[0].price)
        }
        let lastPrice = ''
        if (small_price && large_price && small_price !== large_price) {
          lastPrice = small_price + '~' + large_price
        } else if (small_price || large_price) {
          lastPrice = small_price || large_price
        } else {
          lastPrice = row.price
        }

        publish.editSupply(requestData).then(({ data: res }) => {
          if (res.status === 0) {
            this.pClose(row.supply_id)
            this.$message('更新成功')
            this.list
              .filter(x => x.supply_id == row.supply_id)
              .map(i => {
                i.lastPrice = lastPrice
                return i
              })
          } else {
            this.pClose(row.supply_id)
            this.$message(res.user_msg)
          }
        })
      },
      2000,
      true
    ),
    pCancel(id) {
      this.pClose(id)
    },
    pClose(id) {
      this.$refs[`popover_${id}`].doClose()
      this.ajaxLock = false
    },
    pOpen(id) {
      // 调当前项信息接口
      publish.getSupplyDetail({ supply_id: id }).then(({ data: res }) => {
        const {
          category_id_lvl1,
          category_id_lvl2,
          product_id,
          breed_id,
          unit,
          location_id,
          adcode,
          country_code,
          additional,
          video_img,
          title,
          advanced = [],
          stall,
          supplies_sku
        } = res
        this.curPartSupplyObj = {
          supply_id: id,
          category_id_lvl1,
          category_id_lvl2,
          product_id,
          breed_id,
          unit,
          location_id,
          adcode,
          country_code,
          additional,
          video_img,
          title,
          advanced,
          stall
        }
        // 初始化输入框内容
        this.list
          .filter(x => id == x.supply_id)
          .map(i => {
            i.supplies_sku = supplies_sku.map(m => {
              return { price: m.price / 100, title: m.title, unit: m.unit }
            })
            return i
          })
      })
      // this.$refs[`popover_` + id].doShow()
    },
    formatRefreshTime: function(row) {
      let time = row.updated_time
      let idx = time.indexOf('最后刷新时间')
      return time.substr(idx + 6)
    },
    refresh: utils.debounce(
      function(supplyId) {
        this.refreshedList = Array.from(
          new Set(this.refreshedList.concat(supplyId))
        )
        supply.refresh({ supplyId }).then(({ data: res }) => {
          if (res.status == 0) {
            this.$message('刷新成功')
          } else {
            this.$message(res.user_msg)
          }
          // 刷新去掉前面复选框
          this.$refs.multipleTable.clearSelection()
        })
      },
      1000,
      true
    ),
    toInStock: utils.debounce(
      function(supplyId) {
        supply
          .open({ supply_id: supplyId, is_twice_ok: 1 })
          .then(({ data: res }) => {
            if (res.status === 0) {
              this.list = this.list.filter(x => x.supply_id != supplyId)
              this.$message({
                type: 'success',
                message: '上架成功!'
              })
            } else {
              if (
                res.status == -1 &&
                res.popup &&
                res.popup.pop_payload &&
                res.popup.pop_payload.sub_title &&
                res.popup.pop_payload.title
              ) {
                this.$alert(
                  res.popup.pop_payload.sub_title,
                  res.popup.pop_payload.title,
                  {
                    confirmButtonText: '确定'
                  }
                )
              } else {
                this.$message(res.user_msg || '上架失败')
              }
            }
          })
      },
      1000,
      true
    ),
    toOutStock(supplyId) {
      this.$confirm('确定要下架该供应吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.sureToClose(supplyId)
      })
    },
    // 下架商品
    sureToClose(supply_id) {
      supply.close({ supply_id, is_twice_ok: 1 }).then(({ data: res }) => {
        if (res.status === 0) {
          this.list = this.list.filter(x => x.supply_id != supply_id)
          this.$message({
            type: 'success',
            message: '下架成功!'
          })
        } else {
          this.$message(res.user_msg)
        }
      })
    },
    // 删除商品
    suretoDel(supply_id) {
      supply.toDel({ supply_id }).then(({ data: res }) => {
        if (res.status === 0) {
          this.list = this.list.filter(x => x.supply_id != supply_id)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        } else {
          this.$message(res.user_msg)
        }
      })
    },
    toDel(supplyId) {
      this.$confirm('确定要删除该供应吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.suretoDel(supplyId)
      })
    },
    toEdit(supplyId) {
      this.$router.push({ name: 'editSupply', params: { supplyId: supplyId } })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.selectedSupplyIdArr = this.multipleSelection.map(i => i.supply_id)
    },
    refreshAll: utils.debounce(
      function() {
        if (this.ajaxLock) return
        this.ajaxLock = true
        if (this.disableRefreshAll) return
        supply.refreshAll({}).then(({ data: res }) => {
          if (res.status === 0 && !res.user_msg) {
            this.$message('刷新成功')
          } else {
            this.$message(res.user_msg)
          }
          this.disableRefreshAll = true
          this.ajaxLock = false
        })
      },
      2000,
      true
    ),
    togglePage(index) {
      // 请求分页
      if (index > 0) {
        this.pageStart = (index - 1) * this.pageSize
        this.list = []
        this.getList()
        this.curPage = index
      }
    },
    getList() {
      supply
        .getList({
          onSale: this.typeId,
          pageStart: this.pageStart,
          pageSize: this.pageSize
        })
        .then(({ data: res }) => {
          if (res.status === 0) {
            // if (this.page === 0) {
            this.list = res.list.map(i => {
              i.supplies_sku.map(sku => {
                sku.price = sku.price / 100 - ''
                return sku
              })
              let large_price = i.supplies_sku.reduce((large, cur) => {
                if (large < cur.price - '') {
                  large = cur.price
                }
                return large
              }, 0)
              let small_price = ''
              if (i.supplies_sku.length) {
                small_price = i.supplies_sku.reduce((small, cur) => {
                  if (small > cur.price - '') {
                    small = cur.price
                  }
                  return small
                }, i.supplies_sku[0].price)
              }
              let lastPrice = ''
              if (small_price && large_price && small_price !== large_price) {
                lastPrice = small_price + '~' + large_price
              } else if (small_price || large_price) {
                lastPrice = small_price || large_price
              } else {
                lastPrice = i.price
              }
              i.lastPrice = lastPrice
              return i
            })
            this.totalCount = res.cnt
            this.pageCount = Math.ceil(res.cnt / this.pageSize) || 1
          }
        })
    },
    // 刷新 多个
    refreshMulti: utils.debounce(
      function() {
        if (!this.selectedSupplyIdArr.length) {
          this.$message('请先勾选要刷新数据')
          return
        }
        this.refreshedList = Array.from(
          new Set(this.refreshedList.concat(this.selectedSupplyIdArr))
        )

        for (let supplyId of this.selectedSupplyIdArr) {
          this.refresh(supplyId)
        }
      },
      3000,
      true
    ),
    // 下架 多个
    closeMulti: utils.debounce(
      function() {
        if (!this.selectedSupplyIdArr.length) {
          this.$message('请先勾选要下架的供应')
          return
        }
        this.$confirm('确定要下架所选的供应吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          for (let supplyId of this.selectedSupplyIdArr) {
            this.sureToClose(supplyId)
          }
        })
      },
      3000,
      true
    ),
    // 删除 多个
    delMulti: utils.debounce(
      function() {
        if (!this.selectedSupplyIdArr.length) {
          this.$message('请先勾选要下架的供应')
          return
        }
        this.$confirm('确定要删除所选的供应吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          for (let supplyId of this.selectedSupplyIdArr) {
            this.suretoDel(supplyId)
          }
        })
      },
      3000,
      true
    )
  }
}
</script>

<style lang="less" scoped>
@xs-margin: 10px;
@md-margin: 20px;
.wrapper {
  // min-width: 960px;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;
}
.hd {
  display: flex;
  justify-content: space-between;
  margin-bottom: @md-margin;
  .btn {
    background: #ffffff;
    border: 1px solid #b7b7b7;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #333;
    &.btn_refresh {
      width: 138px;
      height: 30px;
    }
    &.btn_primary {
      width: 66px;
      height: 30px;
    }
    &.disabled {
      color: #666;
      border-color: transparent;
      background: #dedede;
    }
    & > img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
  }
  .operate_bar {
    display: flex;
    justify-content: flex-end;
    & > .btn {
      margin-left: 20px;
    }
  }
}
// .list_main {
.select_area {
  min-width: 36px;
}
.goods {
  display: flex;
  box-sizing: border-box;
}
.refresh_time {
  display: flex;
  align-items: center;
}
.view_num {
  display: flex;
  align-items: center;
}
// .operation {
//   width: 16%;
// }
// }
.list_thead {
  padding: 0 10px;
  display: flex;
  align-items: center;
  height: 34px;
  background: #f2f2f2;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
}
.goods {
  display: flex;
  .main_pic {
    width: 60px;
    height: 60px;
    margin-right: @xs-margin;
  }
  .detail {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    & > .name {
      min-width: 192px;
      font-size: 12px;
      color: #333333;
      word-break: break-all;
      line-height: 1.4;
      cursor: pointer;
      height: 34px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      & > .subname:hover {
        color: #3388ff;
        text-decoration: underline;
      }
    }
    & > .supply_no {
      font-size: 12px;
      color: #999999;
    }
  }
}
.price {
  display: flex;
  align-items: center;
  height: 60px;
  color: #ff4f01;
  font-weight: bold;
}
.options {
  word-break: break-all;
}
.operation {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .btn {
    font-size: 12px;
    color: #3388ff;
    margin-left: @xs-margin;
    background-color: transparent;
    & > img {
      width: 18px;
      height: 18px;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 10px;
    }
    &.disabled {
      color: #abceff;
      border-color: #abceff;
    }
  }
}
// }
.tip {
  display: inline-block;
  margin-left: 30px;
  margin-top: @xs-margin;
  background: rgba(244, 53, 48, 0.06);
  border-radius: 2px;
  font-size: 12px;
  color: #f43530;
  height: 25px;
  line-height: 25px;
  padding: 4px 4px 4px 0;
  & > span {
    vertical-align: middle;
  }
  & > img {
    width: 12px;
    height: 12px;
    margin: 0 4px;
    vertical-align: middle;
    display: inline-block;
  }
}
//   }
// }
.form_control {
  &.no_border {
    border: 0 none;
  }
  &.v_centerlize {
    display: flex;
    align-items: center;
  }
  border: 1px solid #b7b7b7;
  border-radius: 2px;
  font-weight: 500;
  height: 30px;
  box-sizing: border-box;
  &.money_input {
    margin-left: @xs-margin;
    &::before,
    &::after {
      position: absolute;
      content: "";
      left: 15px;
      top: 50%;
      width: 30px;
      height: 28px;
      background: #f2f2f2;
      transform: translate(-50%, -50%);
    }
    &::after {
      content: "￥";
      left: 20px;
      top: 19px;
      background: transparent;
    }
    position: relative;
    width: 100px;
    height: 30px;
    & > input {
      padding-left: 40px;
    }
  }
  & > input {
    width: 100%;
    padding: 5px 10px;
    font-size: 14px;
    color: #999;
    box-sizing: border-box;
  }
}
.sku_row {
  margin-bottom: 20px;
}
.sku_row:last-child {
  margin-bottom: 10px;
}
.sku_desc {
  font-size: 12px;
  padding-left: 57px;
}
.btn_operate {
  width: 64px;
  height: 30px;
  border: 1px solid currentColor;
  border-radius: 2px;
  color: #666;
  background: transparent;
}
.btn_operate_confirm {
  color: #00ac8b;
}
.paginator_wrap {
  margin-top: 0.6rem;
}

.refuse {
  z-index: 99;
  height: 25px;
  line-height: 25px;
  position: absolute;
  margin-top: -20px;
}
.refuse_hd {
  display: flex;
  align-items: center;
  background: rgba(244, 53, 48, 0.06);
  height: 25px;
  line-height: 25px;
  max-width: 700px;
  border-radius: 2px;
  font-size: 12px;
  color: #f43530;
  padding: 0 4px;
  & > img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}
</style>
